
import firebase from "firebase";
import jQuery from "jquery";
let $ = jQuery;
import db from "@/components/firebaseInit";
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import common from "@/common";

Vue.use(VueMoment, {
	moment,
});

let chatDBRef;
let vm;
export default {
	sessionTypeId: 0,
	sessionId: "",
	roomId: "",
	roundTableId: "",
	meetingId: "",
	userType: 4,
	uid: "",
	name: "",
	profileImage: "",
	chatCollectionName: "",
	allChats: [],
	oldChatLoaded: false,
	NewChat: false,
	isChatPanelOpend: false,
	unreadChatCount: 0,
	allReactions: [
		{
			id: 'Reaction_1',
			rev_id: 'Reaction_2',
			code: 'mdi-thumb-up',
			title: 'Thumbs Up',
			color: '#4080ff',
			order: 1
		},
		{
			id: 'Reaction_3',
			code: 'mdi-cards-heart',
			title: 'Heart',
			color: '#f25268',
			order: 2
		},
		{
			id: 'Reaction_4',
			code: 'mdi-emoticon-excited',
			title: 'Excited',
			color: '#ffd972',
			order: 3
		},
		{
			id: 'Reaction_5',
			code: 'mdi-emoticon-cool',
			title: 'Cool',
			color: '#ffd972',
			order: 4
		},
		{
			id: 'Reaction_6',
			code: 'mdi-emoticon-cry',
			title: 'Cry',
			color: '#ffd972',
			order: 5
		},
		{
			id: 'Reaction_7',
			code: 'mdi-emoticon-angry',
			title: 'Angry',
			color: '#F45768',
			order: 6
		},
		{
			id: 'Reaction_2',
			rev_id: 'Reaction_1',
			code: 'mdi-thumb-down',
			title: 'Thumbs Down',
			color: '#4080ff',
			order: 7
		},
	],

	initChat(sessionTypeId, sessionId, roundTableId, meetingId, userType, roomId, eventCollectioNname) {
		vm = this;
		vm.initVars();
		let myApp = window.localStorage.getItem("my-app");
		myApp = myApp == undefined ? "" : myApp;
		myApp = myApp == null ? "" : myApp;
		var obj = JSON.parse(myApp);

		if (obj != undefined && obj != null) {
			vm.chatCollectionName = obj.eventcollectionname;
			if (!vm.chatCollectionName) {
				vm.chatCollectionName = eventCollectioNname;
			}
			vm.uid = obj.user[0].id;
			vm.name = obj.user[0].name;
			vm.profileImage = obj.user[0].profilepic;
		}
		if (vm.chatCollectionName != "") {
			vm.sessionTypeId = sessionTypeId;
			vm.sessionId = sessionId;
			vm.roomId = roomId;
			vm.roundTableId = roundTableId;
			vm.meetingId = meetingId;
			vm.userType = userType;
			if (vm.sessionTypeId == 4 && vm.roundTableId != "") {
				vm.chatCollectionName += "/UserVideoActivity/RoundTable";
				vm.chatCollectionName += "/" + vm.roundTableId;
				if (!vm.roomId) {
					vm.chatCollectionName += "/Chat";
				} else {
					vm.chatCollectionName += "/BreakoutRooms/" + vm.roomId + "/Chat";
				}
			}
			else if ([1, 2, 3].includes(vm.sessionTypeId) && vm.sessionId != "") {
				vm.chatCollectionName += "/UserVideoActivity/Session";
				vm.chatCollectionName += "/" + vm.sessionId;
				if (!vm.roomId) {
					vm.chatCollectionName += "/Chat";
				} else {
					vm.chatCollectionName += "/BreakoutRooms/" + vm.roomId + "/Chat";
				}
			} else if (vm.sessionTypeId == 6 && vm.meetingId != "") {
				vm.chatCollectionName += "/UserVideoActivity/OneToOneMeeting";
				vm.chatCollectionName += "/" + vm.meetingId + "/Chat";
			} else if (vm.sessionTypeId == 7 && vm.meetingId != "") {
				vm.chatCollectionName += "/UserVideoActivity/ExhibitorMeeting";
				vm.chatCollectionName += "/" + vm.meetingId + "/Chat";
			} else if (vm.sessionTypeId == 100 && vm.meetingId != "") {
				vm.chatCollectionName += "/UserVideoActivity/ChatRoom";
				vm.chatCollectionName += "/" + vm.meetingId + "/Chat";
			}
			else {
				return;
			}
			if (chatDBRef) {
				chatDBRef();
			}
			chatDBRef = db
				.collection(vm.chatCollectionName)
				.onSnapshot((snapshot) => {
					let changes = snapshot.docChanges();
					let chatCount = 0;
					changes.forEach(function (change) {
						//alert(change.type);
						if (change.type == "added") {
							let data = change.doc.data();
							if (vm.oldChatLoaded) {
								data.read = false;
							}
							else {
								data.read = true;
							}
							if (data.Message) {
								data.Message = data.Message.trim();
							}
							if (data.Message != "") {
								data = vm.preapareMessage(data);
								//data.revision = 0;
								vm.allChats.push(data);
								if (vm.userType < 4 || !data.SendTo) {
									chatCount++;
								}
								vm.NewChat = true;
							}
						}
						else if (change.type == "modified") {
							//alert("modified");
							debugger;
							let data = change.doc.data();
							data = vm.preapareMessage(data);
							//data.revision++;
							for (var i = 0; i < vm.allChats.length; i++) {
								if (vm.allChats[i].ChatId == data.ChatId) {
									data.read = false;
									vm.allChats[i] = data;
									break;
								}
							}
							vm.NewChat = false;
							//var chats = vm.allChats.filter((item) => {
							//	return item.ChatId == data.ChatId;
							//});
							//if (chats.length > 0) {
							//	//alert("found");
							//	//vm.allReactions.forEach((item) => {

							//	//});
							//	chats[0] = data;
							//}
							vm.allChats = vm.allChats.filter(() => {
								return true;
							});
						}
						//else if (change.type == "removed") {
						//}
					});
					if (vm.oldChatLoaded) {
						//let changesCount = changes.length;
						//console.log(chatCount)
						//if (!vm.isChatPanelOpend) {
						if (!$("#btn_message").hasClass("active")) {
							vm.unreadChatCount += chatCount;
						}
						var chats = vm.allChats.filter((item) => {
							return !item.read;
						});
						vm.unreadChatCount = chats.length;
					}
					vm.oldChatLoaded = true;
				});
			//.catch(function (error) {
			//	console.error("Error creating speaker: ", error);
			//});
		}
	},
	preapareMessage(data) {
		data.CreatedDateStr = vm.formatDatetime(data.CreatedDate);
		if (data.CreatedBy == vm.uid) {
			data.UaserClass = "right-align";
		}
		else {
			data.UaserClass = "";
		}
		let message = data.Message.split(" ");
		for (let i = 0; i < message.length; i++) {
			message[i] = message[i].trim();
			if (vm.isValidURL(message[i])) {
				message[i] = "<a href='" + message[i] + "' target='_blank'>" + message[i] + "</a>";
			}
			else if (vm.isValidEmail(message[i])) {
				message[i] = "<a href='mailto:" + message[i] + "' target='_blank'>" + message[i] + "</a>";
			}
			data.Message = message.join(" ");
		}
		data.NameInitial = common.getInitials(data.Name);
		return data;
	},
	isValidURL: function (url) {
		var urlPattern = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
		//var urlPattern = /^http[s]*\:\/\/[wwW]{3}\.+[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|^http[s]*\:\/\/[^w]{3}[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|http[s]*\:\/\/[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}.*$/;
		var regex = new RegExp(urlPattern);
		return regex.test(url);
	},
	isValidEmail: function (email) {
		var emailPattern = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
		var regex = new RegExp(emailPattern);
		return regex.test(email);
	},
	initVars() {
		vm.sessionTypeId = 0;
		vm.sessionId = "";
		vm.roomId = "";
		vm.roundTableId = "";
		vm.meetingId = "";
		vm.uid = "";
		vm.name = "";
		vm.profileImage = "";
		vm.channelName = "";
		vm.chatCollectionName = "";
		vm.allChats = [];
		vm.oldChatLoaded = false;
		vm.isChatPanelOpend = false;
		vm.unreadChatCount = 0;
	},

	addChat(msg, sendTo) {
		let chatId = new Date().getTime().toString();
		if (!vm.name || !vm.profileImage) {
			let myApp = window.localStorage.getItem("my-app");
			if (myApp) {
				var obj = JSON.parse(myApp);
				if (obj.user[0].name) {
					vm.name = obj.user[0].name;
				}
				if (obj.user[0].profilepic) {
					vm.profileImage = obj.user[0].profilepic;
				}
			}
			// let user = vm.getSessionUserProfile();
			// if (user.Name) {
			// 	vm.name = user.Name;
			// }
			// if (user.ProfileImageURL) {
			// 	vm.profileImage = user.ProfileImageURL;
			// }
		}
		let chatObj = new Object({ ChatId: chatId, CreatedDate: new Date(), CreatedBy: vm.uid, LastModifiedDate: new Date(), Name: vm.name, ProfilePictureURL: vm.profileImage, Message: msg });
		if (sendTo) {
			chatObj["SendTo"] = parseInt(sendTo);
		}
		db.collection(vm.chatCollectionName)
			.doc(chatId).set(chatObj).then(function () {
				//
			});
	},

	sendMessageReaction(chatId, reactionId) {
		var chats = vm.allChats.filter((item) => item.ChatId == chatId);
		if (chats.length > 0) {
			var reactionKey = reactionId;
			var addReaction = true;
			if (reactionKey) {
				if (chats[0][reactionKey] && chats[0][reactionKey].includes(vm.uid)) {
					addReaction = false;
				}
			}
			else {
				addReaction = false;
			}
			if (addReaction) {
				db.collection(vm.chatCollectionName)
					.doc(chatId).update({
						[reactionKey]: firebase.firestore.FieldValue.arrayUnion(vm.uid),
						LastModifiedDate: new Date()
					}).then(function () {
						//
					});
			}
			else {
				db.collection(vm.chatCollectionName)
					.doc(chatId).update({
						[reactionKey]: firebase.firestore.FieldValue.arrayRemove(vm.uid),
						LastModifiedDate: new Date()
					}).then(function () {
						//
					});
			}
		}
	},

	formatDatetime(date) {
		let today = moment(new Date).format("MMM DD, ");
		let datetime = new Date(date.seconds * 1000)
		let dateStr = moment(datetime).format("MMM DD, HH:mm");
		return dateStr.replace(today, "");
	},
};